import React from 'react';
import PropTypes from 'prop-types';

export function TrashIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="icon-svg">
      <path d="M9 3h6l1 2h4v2H4V5h4l1-2zm1 7h2v8h-2v-8zm4 0h2v8h-2v-8zM7 10h2v8H7v-8z" fill="currentColor" />
    </svg>
  );
}

export function EditIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="icon-svg">
      <path d="M3 17.25V21h3.75L17.8 9.94l-3.75-3.75L3 17.25Zm2.92 2.33H5v-.92l8.06-8.06.92.92L5.92 19.58ZM20.7 7.04a1 1 0 0 0 0-1.41L18.37 3.3a1 1 0 0 0-1.41 0l-1.55 1.55 3.75 3.75 1.54-1.56Z" fill="currentColor" />
    </svg>
  );
}

export function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="icon-svg">
      <path d="M9.2 16.2 4.8 11.8l-1.4 1.4 5.8 5.8L20.6 7.6l-1.4-1.4-10 10Z" fill="currentColor" />
    </svg>
  );
}

export function XIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="icon-svg">
      <path d="m18.3 5.7-1.4-1.4L12 9.17 7.1 4.3 5.7 5.7 10.6 10.6 5.7 15.5l1.4 1.4 4.9-4.9 4.9 4.9 1.4-1.4-4.9-4.9 4.9-4.9Z" fill="currentColor" />
    </svg>
  );
}

export function ReadyIcon({ title }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="status-file-icon status-file-icon-ready" title={title}>
      <path d="M7 3h7l5 5v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm6 1.5V9h4.5L13 4.5ZM9 13h2v-2h2v2h2v2h-2v2h-2v-2H9v-2Z" fill="currentColor" />
    </svg>
  );
}

ReadyIcon.propTypes = {
  title: PropTypes.string,
};

export function SpinnerIcon({ title }) {
  return <span className="status-spinner" aria-hidden="true" title={title} />;
}

SpinnerIcon.propTypes = {
  title: PropTypes.string,
};

export function RadarIcon({ title }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="status-file-icon status-file-icon-scan status-file-icon-radar" style={{ color: '#c2410c' }} title={title}>
      <circle className="scan-radar-ring" cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" strokeWidth="1.25" opacity="0.24" />
      <circle className="scan-radar-ring scan-radar-ring-inner" cx="12" cy="12" r="4.5" fill="none" stroke="currentColor" strokeWidth="1.1" opacity="0.34" />
      <path className="scan-radar-sweep" d="M12 12 L19.2 7.8 A8.5 8.5 0 0 1 12 20.5 Z" fill="currentColor" opacity="0.11" />
      <circle className="scan-radar-dot" cx="16.6" cy="8.9" r="1.1" fill="currentColor" />
    </svg>
  );
}

RadarIcon.propTypes = {
  title: PropTypes.string,
};

export function ShieldCheckIcon({ title }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="status-file-icon status-file-icon-clean" title={title}>
      <path d="M12 2 5 5v6c0 4.9 3.4 9.2 7 11 3.6-1.8 7-6.1 7-11V5l-7-3Zm-1 14-3.5-3.5 1.4-1.4 2.1 2.1 4.1-4.1 1.4 1.4L11 16Z" fill="currentColor" />
    </svg>
  );
}

ShieldCheckIcon.propTypes = {
  title: PropTypes.string,
};

export function ShieldXIcon({ title }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="status-file-icon status-file-icon-quarantine" title={title}>
      <path d="M12 2 5 5v6c0 4.9 3.4 9.2 7 11 3.6-1.8 7-6.1 7-11V5l-7-3Zm2.8 6.2 1.4 1.4L13.4 12l2.8 2.8-1.4 1.4L12 13.4l-2.8 2.8-1.4-1.4 2.8-2.8-2.8-2.8 1.4-1.4 2.8 2.8 2.8-2.8Z" fill="currentColor" />
    </svg>
  );
}

ShieldXIcon.propTypes = {
  title: PropTypes.string,
};

export function AlertIcon({ title }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="status-file-icon status-file-icon-failed" title={title}>
      <path d="M12 3 1.8 20h20.4L12 3Zm1 13h-2v-2h2v2Zm0-4h-2V8h2v4Z" fill="currentColor" />
    </svg>
  );
}

AlertIcon.propTypes = {
  title: PropTypes.string,
};

export function StatusIcon({ tone, title }) {
  const iconProps = title ? { title } : {};

  if (tone === 'clean') {
    return <ShieldCheckIcon {...iconProps} />;
  }

  if (tone === 'quarantine') {
    return <ShieldXIcon {...iconProps} />;
  }

  if (tone === 'failed') {
    return <AlertIcon {...iconProps} />;
  }

  if (tone === 'scan') {
    return <SpinnerIcon {...iconProps} />;
  }

  if (tone === 'busy') {
    return <SpinnerIcon {...iconProps} />;
  }

  if (tone === 'ready') {
    return <ReadyIcon {...iconProps} />;
  }

  return <SpinnerIcon {...iconProps} />;
}

StatusIcon.propTypes = {
  tone: PropTypes.oneOf(['clean', 'quarantine', 'failed', 'scan', 'busy', 'ready']),
  title: PropTypes.string,
};
